import React, { useEffect, useState, useRef } from "react";
import useHttp from '../../../../hook/use-http';
import NoData_Jupiter from "../NoData_Jupiter";
import ChartLoader_Jupiter from "../ChartLoader_Jupiter";
import moment from 'moment';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import { BsZoomIn } from "react-icons/bs";

import Chart from 'react-apexcharts'
import WaterMark from "../../DashboardMain_Jupiter/WaterMark";

export default function ROCFleetScatter_Jupiter({ apiend, gloablfilter, type }) {
  const [chartdata, setChartData] = useState([]);
  const [selectedD, setselectedD] = useState(new Date());
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const [width, setWidth] = useState(window.innerWidth);
  const [barColor, setBarColor] = useState("#348393")

  const [textX, setTextX] = useState("Vehicle count")

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  const isMobile = width < 768
  const issmMobile = width < 385;

  const appyData = (data) => {
    const res_result = data;
    const date_display = data.date_display;

    if (res_result.length != 0) {
      let temp_result = res_result;
      let res_result_final = [{
        name: "ROC",
        data: []
      }]

      temp_result.map((x, i) => {
        res_result_final[0].data.push([parseInt(i + 1), x.ROC_percentile.values["50.0"].toFixed(2)]);
      })

      setChartData((prestate) => res_result_final);
      setselectedD(moment(new Date(date_display)).toDate());
      window.dispatchEvent(new Event('resize'));
    } else {
      setChartData((prestate) => []);
      setselectedD(moment(new Date(date_display)).toDate());
      window.dispatchEvent(new Event('resize'));
    }
  }
  let xvalue, yvalue;
  if (isMobile === true) {
    xvalue = 85; yvalue = 80
  }
  else {
    xvalue = 85; yvalue = 78
  }

  const options = {
    chart: {
      toolbar: {
        show: false
      },
      type: 'scatter',
    },
    colors: [barColor],
    grid: {
      show: false,
    },
    yaxis: {
      title: {
        text: "ROC %/hr",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        }
      },
      tickAmount: 7,
      show: true,
    },
    xaxis: {
      position: 'bottom',
      decimalsInFloat: false,
      tickAmount: 7,
      title: {
        text: textX,
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        },
        offsetY: yvalue,
      },
      labels: {
        formatter: function (val) {
          return parseInt(val);
        }
      }
    }
  };

  const options1 = {
    chart: {
      toolbar: {
        show: false
      },
      type: 'scatter',
    },
    colors: [barColor],
    grid: {
      show: false,
    },
    yaxis: {
      title: {
        text: "ROC %/hr",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        }
      },
      tickAmount: 7,
      show: true,
    },
    xaxis: {
      position: 'bottom',
      decimalsInFloat: false,
      tickAmount: 7,
      title: {
        text: textX,
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        },
        offsetY: xvalue,
      },
      labels: {
        formatter: function (val) {
          return parseInt(val);
        }
      }
    }
  };

  useEffect(() => {
    if (type === "Slow") {
      setTextX("Vehicle count")
    } else {
      setTextX("Vehicle count")
    }

    (type === 'Slow') ? setBarColor("#348393") : setBarColor("#FFA650")
    fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/" + apiend, body: { filterdata: gloablfilter, type: type } }, appyData)
  }, [gloablfilter, type])

  const rezoom = () => {
    window.$('#torquespeedsecond').modal('show');
    window.dispatchEvent(new Event('resize'));
  }

  return (
    <>
      <div className="modal fade" id="torquespeedsecond" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">Rate of charging {type} chrg</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{ height: "400px" }}>
              <WaterMark />
              {(isLoading) ? <ChartLoader_Jupiter /> : ((chartdata.length == 0) ? <NoData_Jupiter /> : <Chart options={options1} series={chartdata} type="scatter" width="100%" height="360px" />)}
            </div>
          </div>
        </div>
      </div>

      <strong className="d-flex justify-content-end" style={{ cursor: "pointer", marginRight: "5px" }} onClick={rezoom} > <BsZoomIn /> </strong>

      <WaterMark />
      {(isLoading) ? <ChartLoader_Jupiter /> : ((chartdata.length == 0) ? <NoData_Jupiter /> : <Chart type="scatter" width="100%" series={chartdata} options={options} />)}
    </>
  );
}
